<div>

  <p>Your purchase is complete!</p>
  <p>You will soon receive an email with instructions on how to login to your account</p>

</div>
